import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    title: '',
    description: '',
    price: 10,
    currency: 'USD',
    turnaroundDays: 3,
    isEnabled: true,
    pendingCount: 0,
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  itemDesign: {},
  containerDesign: {},
};

export const shoutoutSlice = createSlice({
  name: 'shoutout',
  initialState,
  reducers: {
    shoutoutStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign ?? {};

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        title: blockContent?.title ?? '',
        description: blockContent?.description ?? '',
        price: blockContent?.price ?? 10,
        currency: blockContent?.currency ?? 'USD',
        turnaroundDays: blockContent?.turnaroundDays ?? 3,
        isEnabled: blockContent?.isEnabled ?? true,
        pendingCount: blockContent?.pendingCount ?? 0,
        heading: {
          title: blockContent?.heading?.title ?? '',
          description: blockContent?.heading?.description ?? '',
          textAlign: blockContent?.heading?.textAlign ?? 'left',
          image: blockContent?.heading?.image ?? '',
          divider: blockContent?.heading?.divider ?? '',
          position: blockContent?.heading?.position ?? '',
        },
      };
    },
    shoutoutClear: () => initialState,

    shoutoutUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    shoutoutUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    shoutoutUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const {
  shoutoutStore,
  shoutoutClear,
  shoutoutUpdateIsLoading,
  shoutoutUpdateIsActive,
  shoutoutUpdateBlockContent,
} = shoutoutSlice.actions;

export const selectShoutoutIsLoading = (state) => state.shoutout.isLoading;
export const selectShoutoutId = (state) => state.shoutout.id;
export const selectShoutoutUID = (state) => state.shoutout.uid;
export const selectShoutoutSID = (state) => state.shoutout.sid;
export const selectShoutoutBlockContent = (state) => state.shoutout.blockContent;
export const selectShoutoutItemDesign = (state) => state.shoutout.itemDesign;
export const selectShoutoutContainerDesign = (state) => state.shoutout.containerDesign;

export default shoutoutSlice.reducer;
